import { render, staticRenderFns } from "./AreaHead.vue?vue&type=template&id=1ef499fc&scoped=true"
import script from "./AreaHead.vue?vue&type=script&lang=js"
export * from "./AreaHead.vue?vue&type=script&lang=js"
import style0 from "./AreaHead.vue?vue&type=style&index=0&id=1ef499fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef499fc",
  null
  
)

export default component.exports